export default {
  title: 'Métricas',
  share: 'Compartir',
  download: 'Descargar',
  trial: 'Métricas con datos simuladas para el funcionamiento dentro del trial',
  simulatedMetrics: 'Métricas con datos simulados',
  notIncluded: 'Esta funcionalidad no se encuentra incluida en tu licencia actual',
  changeLicense: 'Actualizar mi licencia',
  chartOptions: {
    time: 'Tiempo',
    category: 'Categoría',
    school: 'Escuela',
    intraSchool: 'Intraescuela'
  },
  abilityDevelopment: {
    title: 'Habilidades elegidas por categoría',
    goBackToPreviousChart: 'Volver a gráfico completo',
    allAbilities: 'Todas las Habilidades'
  },
  abilityPerAge: {
    title: 'Habilidades por edad',
    ability: 'Habilidad'
  },
  approachByCategory: {
    title: 'Abordaje por categoría',
    noInfo: 'Aún no hay datos suficientes para representar esta métrica'
  },
  resourceMoreValued: {
    title: 'Aspectos más valorados de los recursos',
    noInfo: 'Aún no hay datos suficientes para representar esta métrica'
  },
  chosenMethodologies: {
    title: 'Metodologías elegidas',
    noInfo: 'Aún no hay datos suficientes para representar esta métrica',
    methodologies: {
      Workshop: 'Taller',
      Project: 'Proyecto',
      Case: 'Caso',
      DidacticSequence: 'Secuencia Didáctica',
      Exercise: 'Ejercicio'
    }
  },
  mostValuedResources: 'Los recursos más valorados por tus docentes',
  timeRangeOptions: {
    last30days: 'Últimos 30 días',
    lastTrimester: 'Último trimestre',
    lastSemester: 'Último semestre',
    lastYear: 'Último año'
  },
  skills: {
    problemResolution: 'Resolución de problemas',
    flexibility: 'Flexibilidad',
    criticalThinking: 'Pensamiento Crítico',
    initiative: 'Iniciativa',
    perseverance: 'Perseverancia',
    creativity: 'Creatividad',
    leadership: 'Liderazgo',
    effectiveCommunication: 'Comunicación efectiva',
    analisis: 'Análisis',
    commitment: 'Compromiso',
    resilience: 'Resilencia',
    teamwork: 'Trabajo en equipo'
  },
  allCategories: 'Todas las categorías',
  allSchools: 'Todas las escuelas',
  aspectResource: {
    innovation: 'Contenido innovador',
    applicability: 'Aplicabilidad en el aula',
    methodology: 'Metodología',
    teacherGuide: 'Guía docente',
    author: 'Autor'
  }
}

export const en = {
  title: 'Metrics',
  share: 'Share',
  download: 'Download',
  trial: 'Metrics with simulated data to run in trial',
  simulatedMetrics: 'Metrics with simulated data',
  notIncluded: 'This functionality is not included in your current license',
  changeLicense: 'Change license',
  chartOptions: {
    time: 'Time',
    category: 'Category',
    school: 'School',
    intraSchool: 'Intraschool'
  },
  abilityDevelopment: {
    title: 'Skills chosen by category',
    goBackToPreviousChart: 'Go back to whole chart',
    allAbilities: 'All Skills'
  },
  abilityPerAge: {
    title: 'Skills by age',
    ability: 'Skills'
  },
  approachByCategory: {
    title: 'Approach by category',
    noInfo: 'There isn\'t enough data to represent this metric'
  },
  resourceMoreValued: {
    title: 'Most valued aspects of resources',
    noInfo: 'There isn\'t enough data to represent this metric'
  },
  chosenMethodologies: {
    title: 'Chosen methodologies',
    noInfo: 'There isn\'t enough data to represent this metric',
    methodologies: {
      Workshop: 'Workshop',
      Project: 'Project',
      Case: 'Case',
      DidacticSequence: 'Didactic Sequence',
      Exercise: 'Exercise'
    }
  },
  mostValuedResources: 'Best valued resources by your teachers',
  timeRangeOptions: {
    last30days: 'Last 30 days',
    lastTrimester: 'Last trimester',
    lastSemester: 'Last semester',
    lastYear: 'Last year'
  },
  skills: {
    problemResolution: 'Problem-solving',
    flexibility: 'Flexibility',
    criticalThinking: 'Critical thinking',
    initiative: 'Initiative',
    perseverance: 'Perseverance',
    creativity: 'Creativity',
    leadership: 'Leadership',
    effectiveCommunication: 'Communication',
    analisis: 'Analisis',
    commitment: 'Commitment',
    resilience: 'Resilience',
    teamwork: 'Teamwork'
  },
  allCategories: 'All categories',
  allSchools: 'All schools',
  aspectResource: {
    innovation: 'Innovative content',
    applicability: 'Applicability in the classroom',
    methodology: 'Methodology',
    teacherGuide: 'Teacher guide',
    author: 'Author'
  }
}

export const ca = {
  title: 'Mètriques',
  share: 'Comparteix',
  download: 'Descarrega',
  trial: 'Mètriques amb dades simulades per al funcionament dins la prova',
  simulatedMetrics: 'Mètriques amb dades simulades',
  notIncluded: 'Aquesta funcionalitat no està inclosa a la teva llicència actual',
  changeLicense: 'Actualitza la meva llicència',
  chartOptions: {
    time: 'Temps',
    category: 'Categoria',
    school: 'Escola',
    intraSchool: 'Entre escoles'
  },
  abilityDevelopment: {
    title: 'Habilitats escollides per categoria',
    goBackToPreviousChart: 'Torna al gràfic complet',
    allAbilities: 'Totes les Habilitats'
  },
  abilityPerAge: {
    title: 'Habilitats per edat',
    ability: 'Habilitat'
  },
  approachByCategory: {
    title: 'Abordatge per categoria',
    noInfo: 'Encara no hi ha dades suficients per representar aquesta mètrica'
  },
  resourceMoreValued: {
    title: 'Aspectes més valorats dels recursos',
    noInfo: 'Encara no hi ha dades suficients per representar aquesta mètrica'
  },
  chosenMethodologies: {
    title: 'Metodologies escollides',
    noInfo: 'Encara no hi ha dades suficients per representar aquesta mètrica',
    methodologies: {
      Workshop: 'Taller',
      Project: 'Projecte',
      Case: 'Cas',
      DidacticSequence: 'Seqüència Didàctica',
      Exercise: 'Exercici'
    }
  },
  mostValuedResources: 'Los recursos más valorados por tus docentes',
  timeRangeOptions: {
    last30days: 'Últimos 30 días',
    lastTrimester: 'Último trimestre',
    lastSemester: 'Último semestre',
    lastYear: 'Último año'
  },
  skills: {
    problemResolution: 'Resolució de problemes',
    flexibility: 'Flexibilitat',
    criticalThinking: 'Pensament crític',
    initiative: 'Iniciativa',
    perseverance: 'Perseverança',
    creativity: 'Creativitat',
    leadership: 'Lideratge',
    effectiveCommunication: 'Comunicació efectiva',
    analisis: 'Anàlisi',
    commitment: 'Compromís',
    resilience: 'Resiliència',
    teamwork: 'Treball en equip'
  },
  allCategories: 'Totes les categories',
  allSchools: 'Totes les escoles',
  aspectResource: {
    innovation: 'Contingut innovador',
    applicability: 'Aplicabilitat a la classe',
    methodology: 'Metodologia',
    teacherGuide: 'Guia docent',
    author: 'Autor'
  }
}
